import React, { useEffect, useState } from "react";
import useFetch from "use-http";
import { useHistory } from "react-router-dom";

import StyledAuthentification from "./StyledAuthentification";

import { ReactComponent as ArrowNextWhite } from "../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as CheckRegister } from "../../assets/icons/checkRegister.svg";
import { ReactComponent as Error } from "../../assets/icons/error.svg";
import { ReactComponent as Warning } from "../../assets/icons/warning-red.svg";

import { Auth } from "../../routes/Constants";

import APIVariables from "../../services/api-variables";
import { errorMessages } from "../../constants/errorMessages.constants";
import Footer from "../common/Footer/Footer";

const Validate = () => {
  const history = useHistory();

  const { post, response } = useFetch(process.env.REACT_APP_BASE_URL);

  const [displayModal, setDisplayMessage] = useState(false);
  const [message, setMessage] = useState({
    title: "",
    description: "",
    isValid: true,
  });

  useEffect(() => {
    checkActivateAccount();
    // eslint-disable-next-line
  }, []);

  async function checkActivateAccount() {
    const uid = window.location.pathname.split("/")[2];
    const token = window.location.pathname.split("/")[3];
    const responseRegister = await post(APIVariables.USERS_ACTIVATE, {
      uid,
      token,
    });

    if (response.status === 200) {
      setDisplayMessage(true);
      setMessage({
        title: "Success",
        description: responseRegister.message,
        isValid: true,
      });
    } else if (response.status === 400) {
      setDisplayMessage(true);
      setMessage({
        title: errorMessages.PASSWORD_LINK_INVALID,
        description: errorMessages.PASSWORD_LINK_INVALID_DESCRIPTION,
        isValid: false,
      });
    } else {
      setDisplayMessage(true);
      setMessage({
        title: response.statusText,
        description: errorMessages.SOMETHING_WENT_WRONG,
        isValid: false,
      });
    }
  }

  function logIn() {
    history.push(Auth.LOGIN);
  }

  return (
    <StyledAuthentification>
      {displayModal && (
        <div className="wrapper-login">
          <div className="wrapper-modal">
            <div className="image">
              {message.isValid ? (
                <CheckRegister />
              ) : response.status === 400 ? (
                <Warning />
              ) : (
                <Error />
              )}
            </div>
            <div className={message.isValid ? "main-text" : "main-text-error"}>
              {message.title}
            </div>
            <div
              className={
                "second-text " + (response.status !== 200 ? "mb-3" : "")
              }
            >
              {message.description}
            </div>
          </div>
          {message.isValid && (
            <div className="wrapper-buttons">
              <button className="green-button" onClick={logIn}>
                Login <ArrowNextWhite />
              </button>
            </div>
          )}
        </div>
      )}
      <Footer />
    </StyledAuthentification>
  );
};
export default Validate;
